'use client';
var classes = {"root":"m_8b3717df","breadcrumb":"m_f678d540","separator":"m_3b8f2208"};

export { classes as default };
//# sourceMappingURL=Breadcrumbs.module.css.mjs.map
